<template>
  <el-dialog class="user-dialog" v-bind="$attrs" v-on="$listeners">
    <div class="el-dialog-body-child">
      <el-form ref="queryForm" :model="queryParams" label-width="80px" :inline="true" class="search-form clearfix">
        <el-form-item class="search-field inventory-out fl" label="商品名称" prop="goodsName">
          <el-input v-model.trim="queryParams.goodsName" placeholder="请输入商品名称" clearable
            @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item class="search-field inventory-out fl five-per-row" label="仓库" prop="wareHouseId">
          <el-cascader aria-hidden="false" :options="wareHouseData" @change="handleQuery" clearable
            :props="defaultProps" v-model="wareHouseId" placeholder="请选择仓库">
            <template slot-scope="{ node, data }">
              <div class="warehouse-item flex-c-b">
                <span>{{ data.wareHouseName }}</span>
                <span class="flex-shrink flex-c-s" v-if="node.isLeaf && !data.disabled"> (<el-text-dict dictType="CAPACITY_STATUS"
                    :type="mixinJudgeWareHouseTypeFun(data.capacityStatus)">{{ data.quantity }}/{{ data.maxQuantity
                    }}</el-text-dict>) </span>
              </div>
            </template>
          </el-cascader>
        </el-form-item>
        <div class="fr">
          <el-button plain @click="resetQuery">重 置</el-button>
          <el-button type="primary" @click="handleQuery">查 询</el-button>
        </div>
      </el-form>
      <div class="table-wrap">
        <div class="tips-box">
          <el-tag type="warning">温馨提示：重新搜索后，需重新勾选并点击保存方可见效。</el-tag><el-button class="search-all-selected"
            type="primary" :disabled="isQueryAllSelected" @click="handleSearchAllSelected"
            size="small">点击查看已选择的商品</el-button>
        </div>
        <div class="table-box">
          <auto-height-table instanceHeight="338" ref="spuTable" :class="{ 'empty': list.length === 0 }" empty-text=" "
            v-loading="loading" :data="list" row-key="wareHouseSpuId" @selection-change="handleSelectionChange"
            @row-click="clickRow">
            <el-table-column type="selection" :reserve-selection="true" width="55" align="center" />
            <el-table-column label="商品信息" prop="goodsName" align="left" min-width="168px">
              <template slot-scope="scope">
                <div class="goods-info flex-c-s">
                  <div class="goods-info-left">
                    <img @click.stop="mixinHandlePreview(scope.row.goodsImgs && scope.row.goodsImgs.split(','))"
                      :src="mixinGetImg(scope.row.goodsImgs && scope.row.goodsImgs.split(',')[0])" width="40px" height="40px"
                      alt="商品图片">
                  </div>
                  <div class="goods-info-right flex-c-c flex-col">
                    <div class="top">
                      <span class="label">名称：</span>
                      <span class="value">{{ scope.row.goodsName }}</span>
                    </div>
                    <div class="bottom">
                      <span class="label">编号：</span>
                      <span class="value">{{ scope.row.goodsSn }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="规格信息" prop="skuListStr" align="left" min-width="168px">
              <template slot-scope="scope">
                <div class="goods-info-right flex-c-c flex-col">
                  <div class="top">
                    <span class="label">规格：</span>
                    <span class="value">{{ scope.row.skuListStr }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">编号：</span>
                    <span class="value">{{ scope.row.spuSn }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="仓库" prop="wareHouseName" align="center" min-width="128px">
              <template slot-scope="scope">
                {{ getWareHouseName(scope.row.wareHouseId) }}
              </template>
            </el-table-column>
            <el-table-column label="生产日期" prop="manufactureDate" align="center" min-width="128px" />
            <el-table-column label="成本单价(元)" prop="costPrice" align="center" min-width="128px" />
            <el-table-column label="库存数量" prop="spuNumber" align="center" min-width="128px" />
          </auto-height-table>
          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize" @pagination="getList" />
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="close">关 闭</el-button>
        <el-button type="primary" @click="save">选 择</el-button>
      </template>
    </div>
  </el-dialog>
</template>
<script>
import { statisticsApi } from "@/api"
import { getPathByTreeValue } from "vue2-element-admin-plugin"
export default {
  props: {
    // 已选择的id
    selectIdArr: {
      type: [Array],
      default: () => {
        return []
      }
    },
    // 仓库数据
    wareHouseData: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 过期库存还是过期预警库存
    spuExpireStatus: {
      type: String,
      default: ""
    }
  },
  watch: {
    selectIdArr(val) {
      if (val && val.length > 0) {
        this.isQueryAllSelected = false
        this.wareHouseSpuIds = this.selectIdArr
        // 渲染选中表格
        this.renderSelectTable()
      } else {
        // 解决编辑出库单成功后再次新增 出库单 点击 新增商品 会默认 选中上次新增的 商品的问题
        this.clearSelection()
      }
    }
  },
  data() {
    return {
      wareHouseId: [],
      defaultProps: {
        checkStrictly: true,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      isQueryAllSelected: false, // 是否已点击查询所有已分配
      //搜索条件参数
      queryParams: {
        goodsName: "", // 
        spuExpireStatus: "", // 保质期预警状态 0 正常 1 即将过期  2 已过期
        wareHouseSpuIds: "", // 
        pageNum: 1,
        pageSize: 10
      },
      loading: false,
      list: [],
      total: 0,
      ids: [], // 已选中的项
      wareHouseSpuIds: [], // 已分配的品牌id列表
      isRenderPage: [], // 已渲染过的列表页码
      listSelectIds: [] // 已渲染过的用户id数据
    }
  },
  created() {
    //获取列表
    this.getList()
  },
  methods: {
    // 库存为0的 禁止选择
    checkSelectable(row, index) {
      if (row.spuNumber === 0) {
        return false
      } else {
        return true
      }
    },
    // 获取仓库名字
    getWareHouseName(val) {
      const list = getPathByTreeValue(this.wareHouseData, val, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },

    close() {

      this.$emit("close")
    },
    // 查询所有已分配的角色
    handleSearchAllSelected() {
      if (this.isQueryAllSelected) { return }
      this.isQueryAllSelected = true // 是否查询已分配
      if (this.wareHouseSpuIds.length === 0) {
        this.$modal.msgWarning("暂未添加任何出库单品，请选择")
        return
      }
      this.queryParams.wareHouseSpuIds = this.wareHouseSpuIds.join(",")
      this.mixinResetForm("queryForm")
      // 得补一个 仓库重置的代码
      this.wareHouseId = []
      this.handleQuery({ isSearchAllSelected: true })
    },
    // 清空选项
    clearSelection(isSearch) {
      this.$refs.spuTable && this.$refs.spuTable.clearSelection()
      this.isRenderPage = []
      this.listSelectIds = []
      this.ids = []
      if (isSearch) {
        return
      }
      this.mixinResetForm("queryForm")
      this.queryParams.pageNum = 1
      this.queryParams.wareHouseSpuIds = ""
      this.wareHouseId = [] // 仓库清空
      this.wareHouseSpuIds = []
      this.getList()
    },
    // 渲染选中的数据
    renderSelectTable() {
      if (
        this.isRenderPage.includes(this.queryParams.pageNum) ||
        this.wareHouseSpuIds.length === 0
      ) {
        return
      }
      this.isRenderPage.push(this.queryParams.pageNum)
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i]
        if (this.wareHouseSpuIds.includes(item.wareHouseSpuId)) {
          this.listSelectIds.push(item.wareHouseSpuId)
          this.$nextTick(() => {
            this.$refs.spuTable && this.$refs.spuTable.toggleRowSelection(item, true)
          })
        }
      }
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.wareHouseSpuId)
    },
    //点击行
    clickRow(row) {
      // 库存为0的不让选择
      if (row.spuNumber === 0) {
        return
      }
      this.$refs.spuTable && this.$refs.spuTable.toggleRowSelection(row)
    },
    /** 搜索按钮操作 data.isSearchAllSelected 是否是查询全部已选列表 不是的话 把搜索条件的brandIds 设置为  "" */
    handleQuery(data) {
      if (!data || !data.isSearchAllSelected) {
        this.isQueryAllSelected = false
        this.queryParams.wareHouseSpuIds = ""
      }
      // 点击搜索时 清空选项 重新开始
      this.clearSelection(true)
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.wareHouseId = []
      this.isQueryAllSelected = false
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList(options) {
      if (options?.type === "sizeChange") {
        this.isRenderPage = []
      }
      this.loading = true
      // 获取仓库id
      if (this.wareHouseId && this.wareHouseId.length > 0) {
        this.queryParams.wareHouseId = this.wareHouseId[this.wareHouseId.length - 1]
      } else {
        this.queryParams.wareHouseId = ""
      }
      this.queryParams.spuExpireStatus = this.spuExpireStatus

      statisticsApi
        .getList(this.queryParams)
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
          this.renderSelectTable()
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    // 保存
    async save() {
      if (this.ids.length === 0) {
        this.$modal.msgWarning("请选择商品")
        return
      }
      // 获取已选中ids没有，listSelectIds有的userId：说明这些用户被移除勾选了
      const removeIds = [...new Set(this.listSelectIds)].filter(
        (item) => !new Set(this.ids).has(item)
      )
      // 获取已选中ids有，listSelectIds没有的userId： 说明这些是新增的
      const addIds = [...new Set(this.ids)].filter(
        (item) => !new Set(this.listSelectIds).has(item)
      )
      // 利用最先的userIds 去除移除勾选的 添加新增的
      let resultIds = []
      // 去掉移除勾选的
      resultIds = [...new Set(this.wareHouseSpuIds)].filter(
        (item) => !new Set(removeIds).has(item)
      )
      // 添加新增的
      resultIds = resultIds.concat(addIds)
      const data = await statisticsApi.findAll({ wareHouseSpuIds: resultIds.join(",") })
      this.$emit("success", data)
    }
  }
}
</script>
<style lang="scss" scoped></style>
